import React, {useEffect, useState} from 'react';
import Editor from "@monaco-editor/react";
import {
    SaveMailTemplateDto,
    useLazyGetApiMailTemplatesByIdQuery,
    useLazyGetApiMailTemplatesQuery,
    usePostApiMailTemplatesSaveMutation
} from "../../api/services/MailTemplates";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/store";
import {setError, setLoading} from "../../features/app/appSlice";
import {t} from "i18next";
import {Button, Card, Switch} from "antd";
import {
    CompanySettingDto,
    useLazyGetApiMCompanySettingsByCompanyIdQuery,
    usePostApiMCompanySettingsMutation
} from "../../api/services/MCompany";

export interface ITemplateEditor {
    template?: any,
    cancel: () => void,
    refresh: () => void
}

const TemplateEditor: React.FC<ITemplateEditor> = ({template, cancel, refresh}) => {
    const [fetchMailTemplate] = useLazyGetApiMailTemplatesByIdQuery()
    const [saveMailTemplate] = usePostApiMailTemplatesSaveMutation()
    const dispatch = useDispatch()
    const [fetchSettings, {data: settings}] = useLazyGetApiMCompanySettingsByCompanyIdQuery()
    const [saveSetting] = usePostApiMCompanySettingsMutation()
    const user = useSelector((state: RootState) => state.auth?.user);
    const [editorHtml, setEditorHtml] = useState('');
    const [subject, setSubject] = useState('');
    const [isActive, setIsActive] = useState(false);
    const [templateDetail, setTemplateDetail] = useState<any>()
    useEffect(() => {
        if (template) {
            getMailTemplate()
        }
    }, [template]);

    const getMailTemplate = async () => {
        try {
            dispatch(setLoading(true));
            var temp = await fetchMailTemplate({
                id: template?.id
            }).unwrap() as any

            getActiveSetting(temp.templateKey)
            setEditorHtml(temp.templateContent);
            setSubject(temp.templateSubject);
            setTemplateDetail(temp)
        } catch (err: any) {
            if (err.status != "PARSING_ERROR")
                dispatch(setError(t('Mail şablonu sorgulanırken hata oluştu')));
        } finally {
            dispatch(setLoading(false));
        }
    }

    const saveTempl = async () => {
        try {
            dispatch(setLoading(true));
            var temp = await saveMailTemplate({
                saveMailTemplateDto: {
                    id: templateDetail?.id,
                    companyId: user?.companyId ?? "",
                    name: templateDetail?.name,
                    desc: templateDetail?.desc,
                    templateKey: templateDetail?.templateKey.replace('Default', ''),
                    templateSubject: subject,
                    templateContent: editorHtml,
                    isDefault: templateDetail?.isDefault
                }
            }).unwrap() as any
        } catch (err: any) {
            if (err.status != "PARSING_ERROR")
                dispatch(setError(t('Mail şablonu kaydedilirken hata oluştu')));
        } finally {
            dispatch(setLoading(false));
        }
    }

    const getActiveSetting = async (key: string) => {
        try {
            dispatch(setLoading(true));
            var settingName = key.replace('Default', '');

            var setting = await fetchSettings({
                companyId: user?.companyId ?? "",
                keys: [settingName]
            }).unwrap()

            let val = (setting as any[])?.find(k => k.key == settingName)?.value

            setIsActive(val != undefined ? val === "true" : false)
        } catch (err: any) {
            if (err.status != "PARSING_ERROR")
                dispatch(setError(t('Ayar çekilirken hata oluştu')));
        } finally {
            dispatch(setLoading(false));
        }
    }

    const saveActiveSetting = async (key: string) => {
        try {
            dispatch(setLoading(true));
            await saveSetting({
                body: [
                    {
                        companyId: user?.companyId ?? "",
                        key: key.replace('Default', ''),
                        value: `${isActive}`
                    }
                ]
            }).unwrap()
        } catch (err: any) {
            if (err.status != "PARSING_ERROR")
                dispatch(setError(t('Ayar kaydedilirken hata oluştu')));
        } finally {
            dispatch(setLoading(false));
        }
    }

    const saveTemplate = async () => {
        await saveTempl()
        await saveActiveSetting(templateDetail?.templateKey)
        refresh()
    }


    return (<>
            <Card className={"flex flex-row mb-2"}
                  classNames={{body: "w-full"}}>
                <div className={"flex flex-row justify-between items-center"}>
                    <div className={"flex flex-row"}>
                        {template.templateKey != "DefaultResetPassword" &&
                            template.templateKey != "ResetPassword" &&
                            template.templateKey != "TargetWeightExceeded" &&
                            template.templateKey != "DefaultTargetWeightExceeded" 
                            &&
                            <>
                                <span className={"font-semibold mr-2"}>Mail gönderimi aktif:</span>
                                <Switch value={isActive} onChange={e => {
                                    setIsActive(e)
                                }}/>
                            </>
                        }
                    </div>

                    <div>
                        <Button type="link" className={"mr-2"} onClick={() => {
                            cancel()
                        }}>İptal</Button>
                        <Button type="primary" onClick={() => {
                            saveTemplate()
                        }}>Kaydet</Button>
                    </div>
                </div>
            </Card>
            <Card className={"flex flex-row mb-2 w-full"}
                  classNames={{body: "w-full"}}>
                <h3 className={"font-semibold mb-2"}>Konu:</h3>
                <input placeholder={`Konu:`}
                       className={"flex w-full"}
                       value={subject}
                       onChange={(e) => {
                           setSubject(e.target.value)
                       }}/>
            </Card>
            <Card className={"flex flex-col mb-2"}>
                <h3 className={"font-semibold mb-2"}>İçerik:</h3>
                <div
                    style={{padding: 10, minHeight: 150}}
                    dangerouslySetInnerHTML={{__html: editorHtml ?? ""}}
                />
            </Card>
            <Card className={"flex flex-col"}>
                <h3 className={"font-semibold mb-2"}>İçerik Kodu:</h3>
                <Editor
                    className={"rounded-lg"}
                    height="300px"
                    defaultLanguage="html"
                    value={editorHtml}
                    onChange={(value) => setEditorHtml(value || '')}
                    theme="vs-light"
                />
            </Card>
        </>
    )
};

export default TemplateEditor;